import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField, Grid } from '@material-ui/core';

class ProfileDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      displayName:"",
      email:"",
      lastLoginTime: "",
      schoolName: "",
    };
    autoBind(this);

    if (this.props.root.getMyUserData()) {
      let myUserData = this.props.root.getMyUserData();
      this.state.displayName = myUserData['display_name'];
      this.state.email = myUserData['email'];
      this.state.lastLoginTime = myUserData['last_login_time'];
      this.state.schoolName = myUserData['school_name'];
    }
  }

  updateProfile() {
    if (this.validateInput() == true) {
      let requestObj = {
        user_id: this.props.root.getMyUserId(),
        email: this.state.email.trim(),
        display_name: this.state.displayName.trim(),
      };
      this.props.root.refs.API.request("user_update", requestObj, this.updateProfileOK, this.updateProfileFail);
    }
  }

  updateProfileOK(res) {
    console.log("update profile ok");
    this.handleClose();
    this.props.root.addNotification(Localization.strings.UPDATED);
  }

  updateProfileFail(err) {
    console.log("update profile fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED);
  }

  handleClose() {
    this.setState({
      open: false
    });
    this.state.open = false;
  }

  displayNameChanged(event) {
    this.setState({
      displayName: event.target.value
    });
    this.state.displayName = event.target.value;
  }

  emailChanged(event) {
    this.setState({
      email: event.target.value
    });
    this.state.email = event.target.value;
  }

  validateInput() {
    let result = true;
    let requirement = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = this.state.email.trim();
    let emailOK = (email.length > 0? requirement.test(email) : true);

    if (this.state.displayName.trim() == "") {
      result = false;
      this.props.root.addNotification(Localization.strings.DISPLAY_NAME_BLANK_REMINDER);
    }
    else if (!emailOK) {
      result = false;
      this.props.root.addNotification(Localization.strings.EMAIL_INCORRECT_REMINDER);
    }
    return result;
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle>{Localization.strings.USER_INFORMATION}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                {Localization.strings.SCHOOL_NAME}
              </Grid>
              <Grid item xs={12} sm={8}>
                {this.state.schoolName}
              </Grid>
              <Grid item xs={12} sm={4}>
                {Localization.strings.LAST_LOGIN_TIME}
              </Grid>
              <Grid item xs={12} sm={8}>
                {this.state.lastLoginTime}
              </Grid>
              <Grid item xs={12} sm={4}>
                {Localization.strings.DISPLAY_NAME}
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  value={this.state.displayName}
                  helperText={Localization.strings.NAME_SHOWN_ON_VITALS}
                  onChange={this.displayNameChanged}
                >
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                {Localization.strings.EMAIL}
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  value={this.state.email}
                  helperText={Localization.strings.CAN_BE_USED_AS_LOGIN_NAME}
                  onChange={this.emailChanged}
                >
                </TextField>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CANCEL}
            </Button>
            <Button color="primary" onClick={this.updateProfile} variant="contained">
              {Localization.strings.UPDATE_PROFILE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ProfileDialog;
